import { ChangeDetectorRef, Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appAutoDisableButton]',
    standalone: false
})
export class AutoDisableButtonDirective implements OnInit {

  @Input() hide: boolean = false

  constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    if (this.hide) {
      this.elementRef.nativeElement.style.display = 'none';
      this.cdr.markForCheck()
    }
  }

}
